import React from 'react';
import PropTypes from 'prop-types';
import { Spinner } from 'react-bootstrap';

const LoadingSpinner = ({ 
  size = 'sm', 
  className = '', 
  variant = 'primary',
  text = 'Loading...',
  showText = true 
}) => {
  return (
    <div className={`d-flex align-items-center justify-content-center ${className}`}>
      <Spinner 
        animation="border" 
        size={size} 
        variant={variant}
        className="me-2"
      />
      {showText && <span className="ms-2">{text}</span>}
    </div>
  );
};

LoadingSpinner.propTypes = {
  size: PropTypes.oneOf(['sm', 'lg']),
  className: PropTypes.string,
  variant: PropTypes.string,
  text: PropTypes.string,
  showText: PropTypes.bool
};

export default LoadingSpinner;
